export enum TooltipEvent {
    INIT = 'tooltip:init'
}
